import { render, staticRenderFns } from "./ConfigDataMartsDataMartDetails.vue?vue&type=template&id=616fb082&scoped=true&"
import script from "./ConfigDataMartsDataMartDetails.vue?vue&type=script&lang=js&"
export * from "./ConfigDataMartsDataMartDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDataMartsDataMartDetails.vue?vue&type=style&index=0&id=616fb082&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616fb082",
  null
  
)

export default component.exports